<template>
    <div>
        <ul class="nav nav-tabs">
            <li v-for="tab in visibleTabs" class="nav-item" :key="tab.name">
                <router-link :to="tab.route" class="nav-link" :class="{ active: $route.name === tab.route.name }">
                    {{ $t(tab.label) }}
                </router-link>
            </li>
        </ul>

        <component v-if="activeComponent" :is="activeComponent" :facilityId="facility.id" ref="settlementType" />
    </div>
</template>

<script>
import ArbitrageSettlement from '../settlement/arbitrage/arbitrage.vue';
import StripeSettlement from '../settlement/stripe/stripe.vue'
import ArbitragePayout from '../payout/arbitrage/arbitrage.vue'
import ArbitrageUnidentified from '../unidentified/arbitrage/arbitrage.vue'
import StripePayout from '../payout/stripe/stripe.vue'

export default {
    components: {
        ArbitrageSettlement,
        StripeSettlement,
        ArbitragePayout,
        StripePayout,
        ArbitrageUnidentified
    },
    data() {
        return {
            isArbitrage: false,
            facility: window._app_facility,
            tabList: [
                {
                    name: 'settlement',
                    label: 'account-page-visitor-payments.title',
                    routeNameArbitrage: 'checkin-facility-dashboard-visitor-payments-settlement-arbitrage',
                    routeNameDefault: 'checkin-facility-dashboard-visitor-payments-settlement',
                    componentArbitrage: 'ArbitrageSettlement',
                    componentDefault: 'StripeSettlement'
                },
                {
                    name: 'payout',
                    label: 'account-page-facility-payout.payout_list',
                    routeNameArbitrage: 'checkin-facility-dashboard-visitor-payments-payout-arbitrage',
                    routeNameDefault: 'checkin-facility-dashboard-visitor-payments-payout',
                    componentArbitrage: 'ArbitragePayout',
                    componentDefault: 'StripePayout'
                },
                {
                    name: 'unidentified',
                    label: 'account-page-visitor-payments.unidentified',
                    routeNameArbitrage: 'checkin-facility-dashboard-visitor-payments-unidentified-arbitrage',
                    routeNameDefault: 'checkin-facility-dashboard-visitor-payments-unidentified',
                    componentArbitrage: 'ArbitrageUnidentified',
                    componentDefault: ''
                }
            ],
            isArbitrage: false,
            isArbitrageChecked: false,
        };
    },
    computed: {
        visibleTabs() {
            return this.tabList
               .filter((tab) => {
                  if(this.isArbitrage == false) {
                     if(tab.name === 'unidentified') {
                        return false;
                     }
                  }
                  return true;
                })
                .map(tab => ({
                    ...tab,
                    route: {
                        name: this.isArbitrage ? tab.routeNameArbitrage : tab.routeNameDefault
                    }
                }));
        },
        activeComponent() {
            if (!this.isArbitrageChecked) return null;
            const currentTab = this.tabList.find(tab =>
                [tab.routeNameArbitrage, tab.routeNameDefault].includes(this.$route.name)
            );
            if (!currentTab) return null;
            return this.isArbitrage ? currentTab.componentArbitrage : currentTab.componentDefault;
        }
    },
    watch: {
        '$route.name': {
            immediate: true,
            async handler() {
                await this.checkIfArbitrage();

                const currentTab = this.tabList.find(tab => {
                    return [tab.routeNameArbitrage, tab.routeNameDefault].includes(this.$route.name);
                });

                if (!currentTab) return;

                const expectedRoute = this.isArbitrage
                    ? currentTab.routeNameArbitrage
                    : currentTab.routeNameDefault;

                if (this.$route.name !== expectedRoute) {
                    this.$router.replace({ name: expectedRoute });
                }
            }
        }
    },
    methods: {
        async checkIfArbitrage() {
            // Only check once per mount: the router.replace to the arbitrage route re-triggers the
            // watcher, and a second request would hide the loading overlay mid settlement-list fetch.
            if (this.isArbitrageChecked) return;
            try {
                const res = await this.$lionheart.post('/facility-setting/list', {
                    facility_id: this.facility.id,
                    name: 'payment-product',
                    paginate: false
                });
                const settings = res?.data?.data || [];
                const paymentProductSetting = settings.find(
                    s => s.name === 'payment-product' && s.value?.enable === true
                );
                this.isArbitrage = !!paymentProductSetting;
            } catch (err) {
                this.isArbitrage = false;
            } finally {
                this.isArbitrageChecked = true;
            }
        },
        doCall() {
            return this.$refs.settlementType;
        }
    }
};
</script>
